module Meevo.Components.Controls.SmartMover {
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    export interface IIncludeObjectStateOptions extends IDataTemplateFilterOptions {
        defaultValue?: boolean;
        displayName: string;
        stateList: ObjectStateEnum[];
        filterProperty: string;
        defaultState?: ObjectStateEnum;
    }

    export class IncludeObjectStateFilter extends InteractiveFilter implements IInteractiveFilter {
        public readonly templateName: FilterTemplateNames = 'include-object-state';

        private readonly _stateList: ObjectStateEnum[];
        private readonly _defaultState: ObjectStateEnum;
        private readonly _filterProperty: string;

        constructor(options: IIncludeObjectStateOptions, dataTemplate: IDataTemplate = null) {
            super({
                ...options,
                labels: {
                    include: options.displayName
                }
            }, dataTemplate);

            this.values.include = options.defaultValue;
            this._stateList = options.stateList;
            this._filterProperty = options.filterProperty;
            this._defaultState = options.defaultState || ObjectStateEnum.Active;
        }

        filter(entities: Meevo.Components.Controls.SmartMover.ISmartMoverModel<any>[]): Meevo.Components.Controls.SmartMover.ISmartMoverModel<any>[] {
            return entities.filter(model => {
                let res;

                if (this.values.include) res = this._stateList.indexOf(model.get(this._filterProperty)) !== -1;
                else res = model.get(this._filterProperty) === this._defaultState;

                if (!res) {
                    model.selected = false;
                    model.collection.onModelValueChanged();
                }

                return res;
            });
        }
    }
}
